/**
 * Type Utilities
 * ฟังก์ชันสำหรับจัดการข้อมูลประเภทน้องๆ
 */

// Type icons และ labels
export const typeConfig = {
  normal: {
    icon: '🌿',
    label: 'ธรรมดา',
    color: 'bg-green-100 text-green-600'
  },
  vn: {
    icon: '💋',
    label: 'วีเอ็น',
    color: 'bg-blue-100 text-blue-600'
  },
  strong: {
    icon: '💪',
    label: 'แรง',
    color: 'bg-red-100 text-red-600'
  },
  up: {
    icon: '🚀',
    label: 'อัพ',
    color: 'bg-purple-100 text-purple-600'
  }
};

/**
 * ดึงข้อมูล type configuration
 * @param {string} type - ประเภทของน้อง (normal, vn, strong, up)
 * @returns {object} ข้อมูล type configuration
 */
export const getTypeConfig = (type) => {
  return typeConfig[type] || {
    icon: '❓',
    label: 'ไม่ระบุ',
    color: 'bg-gray-100 text-gray-600'
  };
};

/**
 * ดึง icon ของ type
 * @param {string} type - ประเภทของน้อง
 * @returns {string} icon
 */
export const getTypeIcon = (type) => {
  return getTypeConfig(type).icon;
};

/**
 * ดึง label ของ type
 * @param {string} type - ประเภทของน้อง
 * @returns {string} label
 */
export const getTypeLabel = (type) => {
  return getTypeConfig(type).label;
};

/**
 * ดึง color class ของ type
 * @param {string} type - ประเภทของน้อง
 * @returns {string} color class
 */
export const getTypeColor = (type) => {
  return getTypeConfig(type).color;
};

/**
 * ดึงรายการ type ทั้งหมดสำหรับ dropdown
 * @returns {Array} รายการ type options
 */
export const getTypeOptions = () => {
  return Object.entries(typeConfig).map(([key, config]) => ({
    value: key,
    label: config.label,
    icon: config.icon,
    color: config.color
  }));
};









